import { z } from "zod";

export const SearchItemSchema = z.object({
  Highlights: z.object({
    Description: z.string().optional(),
    Text: z.string().optional(),
    Title: z.string().optional(),
  }),
  Item: z.object({
    Id: z.string().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    url: z.string().optional(),
  }),
});

export type SearchItemType = z.infer<typeof SearchItemSchema>;
